import styled from 'styled-components';

export const ITeroProposalNotificationContainer = styled.div`
  padding: 20px;
  text-align: center;
  margin-top: 50%;
`;

export const ModalHeader = styled.div`
  font-weight: 500;
  font-size: 1.05rem;
  line-height: 24px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalBody = styled.div`
  padding: 20px;
  line-height: 24px;
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
